var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGestionProductosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1 5.4H45.9C47.3912 5.4 48.6 6.60883 48.6 8.1V45.9C48.6 47.3912 47.3912 48.6 45.9 48.6H8.1C6.60883 48.6 5.4 47.3912 5.4 45.9V8.1C5.4 6.60883 6.60883 5.4 8.1 5.4ZM0 8.1C0 3.62649 3.62649 0 8.1 0H45.9C50.3735 0 54 3.62649 54 8.1V45.9C54 50.3735 50.3735 54 45.9 54H8.1C3.62649 54 0 50.3735 0 45.9V8.1ZM27 27C19.5442 27 13.5 19.747 13.5 10.8H18.9C18.9 17.7284 23.4065 21.6 27 21.6C30.5935 21.6 35.1 17.7284 35.1 10.8H40.5C40.5 19.747 34.4558 27 27 27Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestionProductosIcon);
export default __webpack_public_path__ + "static/media/gestionProductosIcon.0e9280c1afbbc36aefbc0df835029b3a.svg";
export { ForwardRef as ReactComponent };